import React, { useMemo } from 'react';

import { Checkbox } from '@lyearn/ui';

import { useAddTaskModalContext } from '../AddTaskModalProvider';

interface SelectTaskCheckboxProps {
  id: string;
}

function SelectTaskCheckbox(props: SelectTaskCheckboxProps) {
  const { id: taskId } = props;
  const { methods } = useAddTaskModalContext();
  const { isItemSelected } = methods;

  const checked = useMemo(() => isItemSelected(taskId), [isItemSelected, taskId]);

  return <Checkbox checked={checked} data-attr="SELECT" size="small" />;
}

export default SelectTaskCheckbox;
